/** @jsx jsx */
import { jsx } from '@emotion/core';

import React from 'react';
import { RouteComponentProps } from '@reach/router';
import RebateResults from './RebateResults';
import useContentMgmt from '../../../../../hooks/useContentMgmt';
import microcopyGroupIds from '../../../../pge-plus-common/microcopyGroupIds';
import routes from '../../../../../routes';
import { useRebateOnlyFormState } from '../../../../../providers/RebateOnlyFormStateProvider';
import { isLegacyTeslaResumeCustomer } from '../rebateOnlyForm.utils';

const EVPulseRebateResults: React.FC<RouteComponentProps> = (
  props: RouteComponentProps,
) => {
  const { content } = useContentMgmt(
    microcopyGroupIds.PGE_PLUS_REBATE_ONLY_REBATE_RESULTS,
  );
  const {
    formState: { rebateConfirm },
  } = useRebateOnlyFormState();

  // CUP-24447: This screen is now legacy-resume-only.. new vehicle-path customers land on ChargerRebateResults' EVPULSE_REBATE variant instead
  const backRoute = isLegacyTeslaResumeCustomer(rebateConfirm)
    ? routes.PGE_PLUS_REBATE_ONLY_CONNECT_TESLA
    : routes.PGE_PLUS_REBATE_ONLY_VEHICLE_INSTRUCTIONS;

  return (
    <RebateResults
      title={content.get('CHARGER_INSTALLTION_TITLE')}
      eligibilityText={content.get('EVPULSE_REBATE_ELIGIBILITY_TEXT') || ''}
      rebateData={{
        totalRebates: rebateConfirm.evPulseRebateAmount,
      }}
      backRoute={backRoute}
    />
  );
};

export default EVPulseRebateResults;
